import { render, staticRenderFns } from "./branchTrunkInfo.vue?vue&type=template&id=b9418c44&scoped=true"
import script from "./branchTrunkInfo.vue?vue&type=script&lang=js"
export * from "./branchTrunkInfo.vue?vue&type=script&lang=js"
import style0 from "./branchTrunkInfo.vue?vue&type=style&index=0&id=b9418c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9418c44",
  null
  
)

export default component.exports